import { NgModule } from "@angular/core";
import { ButtonModule } from "primeng/button";
import { InputTextModule } from "primeng/inputtext";
import { ImageModule } from "primeng/image";
import { DividerModule } from "primeng/divider";
import { MenubarModule } from "primeng/menubar";
import { PanelMenuModule } from "primeng/panelmenu";
import { AvatarModule } from "primeng/avatar";
import { BadgeModule } from "primeng/badge";
import { SidebarModule } from "primeng/sidebar";
import { MenuModule } from "primeng/menu";
import { ChipModule } from "primeng/chip";
import { CardModule } from "primeng/card";
import { PaginatorModule } from "primeng/paginator";
import { TableModule } from "primeng/table";
import { TabViewModule } from "primeng/tabview";
import { PanelModule } from "primeng/panel";
import { InputSwitchModule } from "primeng/inputswitch";
import { AccordionModule } from "primeng/accordion";

import { ToastModule } from "primeng/toast";
import { CalendarModule } from "primeng/calendar";
import { SliderModule } from "primeng/slider";
import { MultiSelectModule } from "primeng/multiselect";
import { ContextMenuModule } from "primeng/contextmenu";
import { DialogModule } from "primeng/dialog";
import { DropdownModule } from "primeng/dropdown";
import { ProgressBarModule } from "primeng/progressbar";
import { RippleModule } from "primeng/ripple";
import { MessageService } from "primeng/api";
import { ProgressSpinnerModule } from "primeng/progressspinner";
import { InputNumberModule } from "primeng/inputnumber";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { FileUploadModule } from "primeng/fileupload";
import { CheckboxModule } from "primeng/checkbox";
import { ChartModule } from "primeng/chart";
import { SelectButtonModule } from "primeng/selectbutton";
import { InputTextareaModule } from "primeng/inputtextarea";

@NgModule({
  declarations: [],
  imports: [],
  exports: [
    ButtonModule,
    InputTextModule,
    ImageModule,
    TabViewModule,
    DividerModule,
    MenubarModule,
    PanelModule,
    PanelMenuModule,
    AvatarModule,
    BadgeModule,
    SidebarModule,
    MenuModule,
    ChipModule,
    CardModule,
    PaginatorModule,
    TableModule,
    InputSwitchModule,
    ToastModule,
    CalendarModule,
    SliderModule,
    MultiSelectModule,
    ContextMenuModule,
    DialogModule,
    DropdownModule,
    ProgressBarModule,
    RippleModule,
    InputNumberModule,
    ConfirmDialogModule,
    ProgressSpinnerModule,
    FileUploadModule,
    CheckboxModule,
    ChartModule,
    AccordionModule,
    SelectButtonModule,
    InputTextareaModule,
  ],
  providers: [MessageService],
})
export class PrimeNgModule {}
